import Vue from 'vue';
import Component from 'vue-class-component';
import VueRecaptcha from 'vue-recaptcha';
import { Prop } from 'vue-property-decorator';
import EdFormModel from '@/models/ed-form.model';
import EdInputModel from '@/models/ed-input.model';
import { required, maxLength, minLength, email as emailVal } from 'vuelidate/lib/validators';
import { AUTH_EVENTS, USER_TYPE, CAPTCHA_KEYS } from '@/auth/values/auth.values';
import EdPasswordProgressBar from '@/auth/components/ed-password-progress-bar/ed-password-progress-bar.vue'

@Component({
  name: 'ed-register-account-info',
  components: {
    VueRecaptcha,
    EdPasswordProgressBar
  }
})
export default class EdRegisterAccountInfoComponent extends Vue {
  
  /* Props */
  @Prop() readonly userType: any;
  @Prop({ default: 0 }) readonly nextThrottleSeconds: number;

  /* Data */
  public form: any = {};
  public saving: boolean = false;
  public emailMessages: any = [];
  public userTypes: any = USER_TYPE;
  public reCaptcha: boolean = false;
  public reCaptchaKeys: any = CAPTCHA_KEYS;
  public isStrong: boolean = false;
  public differentPass: boolean = false;

  /* Computed */
  get userId () {
    return this.$store.state.AuthStore.user.id;
  }

  get canAdvance() {
    return !this.saving && this.nextThrottleSeconds <= 0 && this.form.valid
      && this.isStrong && !this.differentPass && this.reCaptcha;
  }

  /* Methods */
   private init(username = '', email = '', password = '', passwordConfirmation = '') {
    this.form = EdFormModel([
      EdInputModel('username', username, {required, maxLength: maxLength(60)}, true),
      EdInputModel('email', email, {required, emailVal}, true),
      EdInputModel('password', password, {required, maxLength: maxLength(60), minLength: minLength(8)}, true),
      EdInputModel('passwordConfirmation', passwordConfirmation, { required }, true)
    ]);
  }

  next() {
    if (!this.canAdvance) return;
    this.$emit(AUTH_EVENTS.GET_FORM_ACCOUNT_INFO, this.form)
  }

  goToPrevStep() {
    this.$edEventBus.$emit(AUTH_EVENTS.ON_CHANGE_REGISTER_STEP, {step: 2, userType: this.userType})
  }

  goToInit () {
    this.$edEventBus.$emit(AUTH_EVENTS.ON_CHANGE_REGISTER_STEP, {step: 1, userType: null})
  }

  verifyReCaptcha() {
    this.reCaptcha = true;
  }

  errorReCaptcha() {
    this.reCaptcha = false;
  }
  
  public watchIfStrong(isStrong: boolean) {
    this.isStrong = isStrong;
  }

  public verifyPasswords() {
    this.differentPass = false;
    if (this.form.password.value == '' || this.form.passwordConfirmation.value == '')
      this.differentPass = false;
    else if (this.form.password.value != this.form.passwordConfirmation.value) {
      this.differentPass = true;
    }
  }

  /* Hooks */
  created() {
    this.init();
    this.$edEventBus.$on(AUTH_EVENTS.RESET_ACCOUNT_INFO_FORM, this.init)
  }

  destroyed() {
    this.$edEventBus.$off(AUTH_EVENTS.RESET_ACCOUNT_INFO_FORM, this.init)
  }
}
